// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   //endpoint: 'http://169.38.77.181:8080/NRLM_dev',
   //vprp_endpoint: 'http://169.38.77.181:8080/VPRP_DEV',
   endpoint: "https://pgdev.lokos.in/NRLM_dev/api",
  vprp_endpoint: "https://vprp-pgdev.lokos.in/nrlmum-dev/api",
  error_endpoint: "https://pgdev.lokos.in/NRLM_WEB/#/layout/wrong",
   //error_endpoint: 'http://4.224.60.146:8080/NRLM_WEB/#/layout/wrong',
   _auser: 'PGAdmin',
   _ausername: 'PG Admin',
   _channel: '1001',
   _applicationId:8,
   _applicationrole:208,
   _roleName:"pla",
   _state:29,
   _district:593,
   _blockId:5405,
   _blockCode:3109005,
   _blockNameEn:"KOTWALI",
   _stateCode:31,
   _status:"ACTIVE",
   _geoLevelPermitted:"national,state,district,block",
   _mapToGeographics:true,
   _pwdresetflag:"N"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
